import * as React from "react";
import styled from "styled-components";

const Wrapper = styled.svg`
  width: 100%;
  fill: currentColor;
`;

export const SpinIcon = props => (
  <Wrapper viewBox="0 0 100 100" {...props}>
    <g>
      <path d="M44.697 18.944v10.78c-9.149 2.342-15.91 10.605-15.91 20.438 0 11.656 9.498 21.104 21.213 21.104 11.715 0 21.212-9.448 21.212-21.104a20.967 20.967 0 0 0-5.473-14.148l8.706-6.116a31.43 31.43 0 0 1 7.373 20.264c0 17.483-14.245 31.656-31.818 31.656S18.182 67.645 18.182 50.162c0-15.685 11.466-28.706 26.515-31.218zm0-10.99l22.538 15.828L44.697 39.61V7.955z" />
    </g>
  </Wrapper>
);
